export class ClosingReason {
    name: string;
    id: number;
    code: string;
}
